<app-top-bar-wrapper [type]="DashboardType.MY_BRAND" [attr.data-testid]="DataTestIds.TOP_BAR_WRAPPER">
  <div dashboard class="main-container">
    <app-top-level-metrics [attr.data-testid]="DataTestIds.TOP_LEVEL_METRICS" ></app-top-level-metrics>
    <app-overview-tiles [type]="'brand'" [overview]="overview" [loading]="loadingState.overview" [attr.data-testid]="DataTestIds.OVERVIEW"></app-overview-tiles>
    <div *ngIf="creativeGalleryData.total || creativeGalleryVolumeThreshold" class="widgets-wrapper" [attr.data-testid]="DataTestIds.CREATIVE_GALLERY">
      <div class="widget-container gallery">
      <app-widget-container
        [title]="'Creative Gallery'" [control]="gallerySort" [selectMode]="SelectMode.SINGLE"
        [selectOptions]="gallerySortOptions" [searchable]="false"
        [placeholder]="'Select sort field'"
        [selectDisabled]="!creativeGalleryData.total" [selectAllAndClearOptions]="false"
        [selectWidth]="'248px'"
        [tooltip]="tooltips.creativeGallery"
        [askPolarisWidget]="DashboardWidget.CREATIVE_GALLERY"
        [showVolumeFilter]="true" (volumeFilterApplied)="onCreativeGalleryVolumeFilter($event)"
        (apply)="onSortFieldChange()" [compareWith]="compareOptions">
          <app-creative-gallery *ngIf="creativeGalleryData.total" [data]="creativeGalleryData.creativesData" [loading]="loadingState.creativeGallery" [brandskeys]="[this.getMyBrandKey()]"
            [getterName]="'getMyCreativeCard'" (requestPageChange)="onCreativeModalEdgeNav($event)"></app-creative-gallery>
          <app-no-widget-data *ngIf="!creativeGalleryData.total && !loadingState.creativeGallery"></app-no-widget-data>
        </app-widget-container>
        <div class="paginator-container">
          <app-paginator *ngIf="creativeGalleryData.total" #creativeGalleryPaginator
                         [length]="creativeGalleryData.total" [pageSize]="CREATIVE_GALLERY_PAGE_SIZE" [initialPage]="initialPage"
                         (page)="onCreativeGalleryPageChange($event)"></app-paginator>
        </div>
      </div>
    </div>
    <div class="widgets-wrapper">
      <div class="widget-container audience-interests" [attr.data-testid]="DataTestIds.CONTENT_CATEGORY_BREAKDOWN">
        <app-widget-container [title]="'Audience Interests'" [tooltip]="tooltips.contentCategory">
          <app-pie-chart [data]="contentCategoryBreakDown" [colors]="contentCategoryColors" format="percentage" [isCompactMode]="true"
                         [loading]="loadingState.contentCategory"
                         valueField="share"></app-pie-chart>
        </app-widget-container>
      </div>
      <div class="widget-container audience-gender" [attr.data-testid]="DataTestIds.AUDIENCE_GENDER">
        <app-widget-container [title]="'Audience Reach by Gender'" [tooltip]="tooltips.audienceGender">
          <app-pie-chart [data]="audienceGenderChartData" [colors]="audienceGenderColors" format="percentage"
                         [isCompactMode]="true" [loading]="loadingState.audienceGender" valueField="share">
          </app-pie-chart>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper" [attr.data-testid]="DataTestIds.PERFORMANCE_OVER_TIME">
      <div class="widget-container performance-over-time">
        <app-widget-container
          [title]="'Performance Over Time'" [control]="performanceOverTimeMetricControl"
          [selectMode]="SelectMode.SINGLE" [selectOptions]="performanceMetricOptions" [searchable]="false" [selectWidth]="'248px'"
          [disabledByLength]="true" (apply)="onPerformanceOverTimeMetricChange()" [askPolarisWidget]="DashboardWidget.PERFORMANCE_OVER_TIME">
          <app-performance-over-time
            [data]="performanceOverTimeData" [loading]="loadingState.performanceOverTime" 
            [metric]="performanceOverTimeSelectedOption.key"
            [brandColors]="brandColorsMap()" valueField="share" [format]="performanceOverTimeFormat"
            [isUnderDateThreshold]="performanceOverTimeData?.isUnderDateThreshold || false">
          </app-performance-over-time>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper" [attr.data-testid]="DataTestIds.PERFORMANCE_MAP">
      <div class="widget-container performance-map">
      <app-widget-container
        [title]="'Performance Map'" [control]="performanceMapMetricControl" [selectMode]="SelectMode.SINGLE"
        [selectOptions]="performanceMapMetricOptions" [searchable]="false" [placeholder]="'Select metric'"
        [selectWidth]="'248px'" [selectDisabled]="!(!!performanceMapData.performance && performanceMapData.performance.length > 0)"
        [tooltip]="tooltips.performanceMap"
        [askPolarisWidget]="DashboardWidget.PERFORMANCE_MAP"
        [showVolumeFilter]="true" (volumeFilterApplied)="onPerformanceMapVolumeFilter($event)"
        (apply)="onPerformanceMapMetricChange()">
        <app-performance-map
          [data]="performanceMapData" [loading]="loadingState.performanceMap" [type]="performanceMapType" [metric]="performanceMapSelectedOption">
        </app-performance-map>
        <ng-container *ngIf="performanceMapData.performance?.length">
          <div class="divider"></div>
          <app-tabs
            (emitter)="switchPerformanceMapTab($event)" [tabs]="['Worldwide', 'US']" [styleClass]="'performance-map'">
          </app-tabs>
        </ng-container>
      </app-widget-container>
      </div>
    </div>
    <div class="table-container" [attr.data-testid]="DataTestIds.INVENTORY_QUALITY">
      <div class="table-header-container">
        <div class="table-header">Inventory Quality</div>
        <ng-content *ngIf="inventoryQualityTableData.total">
        </ng-content>
      </div>
      <ng-content *ngIf="inventoryQualityTableData.total || loadingState.inventoryQuality;else noInventoryData">
        <div class="table-content">
          <app-sites-table [tableData]="inventoryQualityTableData.sites" (sortChange)="this.onSortInventoryQualityTable($event)" [loading]="loadingState.inventoryQuality"></app-sites-table>
          <app-paginator #inventoryQualityPaginator [length]="inventoryQualityTableData.total"
                        [pageSize]="inventoryQualityPageSize" [initialPage]="initialPage"
                        (page)="onInventoryQualityPageChange($event)"
                        [rowControl]="true" [rowsTitle]="rowsPerPage" (rowsChange)="onInventoryQualityRowsChange($event)">
          </app-paginator>
        </div>
      </ng-content>
      <ng-template #noInventoryData>
        <app-no-widget-data class="wide-container"></app-no-widget-data>
      </ng-template>
    </div>
  </div>
</app-top-bar-wrapper>
